import { useBoolean } from '@chakra-ui/react';
import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import OutstandingRevenueComponent from '../../../../components/dashboard_components/OutstandingRevenueComponent';
import { CUSTOM } from '../../../../constants/constants';
import departmentDashboardRepository from '../../../../repositories/DepartmentRepository';
import { dateFormat } from '../../../../utils/common.utils';

function DOutstandingRevenue({
  defaultStartDate,
  defaultEndDate,
  startDate,
  endDate,
  filter,
}) {
  const { departmentId } = useParams();
  const [isFetching, ifState] = useBoolean(false);
  const [opporturnityBreakdown, setOpporturnityBreakdown] = useState(null);

  const selectedDates = JSON.parse(
    window.localStorage.getItem('customDateFilter')
  );

  const setCustomDates = filterParams => {
    for (const prop in selectedDates) {
      filterParams[prop] = dateFormat(
        new Date(selectedDates[prop]),
        'yyyy-MM-dd'
      );
    }
  };

  const getOutstandingRevenueData = async () => {
    try {
      ifState.on();
      const filterParams = {};
      filterParams.filter = filter.toLowerCase();
      if (filter === CUSTOM.toLowerCase()) {
        setCustomDates(filterParams);
        // setFilters(
        //   filterParams,
        //   dateFormat(defaultStartDate, 'yyyy-MM-dd'),
        //   dateFormat(defaultEndDate, 'yyyy-MM-dd'),
        //   dateFormat(startDate, 'yyyy-MM-dd'),
        //   dateFormat(endDate, 'yyyy-MM-dd')
        // );
        delete filterParams.filter;
      }
      filterParams.department_id = departmentId;

      const response =
        await departmentDashboardRepository.getOutstandingRevenue(filterParams);
      setOpporturnityBreakdown(response);
      return response;
    } catch (error) {
      setOpporturnityBreakdown(null);
    } finally {
      ifState.off();
    }
  };

  React.useEffect(() => {
    getOutstandingRevenueData();
    // eslint-disable-next-line
  }, [defaultStartDate, defaultEndDate, startDate, endDate, filter]);

  const uiStartDate = dateFormat(defaultStartDate, 'MM/dd/yyyy');
  const uiEndDate = dateFormat(defaultEndDate, 'MM/dd/yyyy');
  return (
    <OutstandingRevenueComponent
      opporturnityBreakdown={opporturnityBreakdown}
      isFetching={isFetching}
      defaultStartDate={uiStartDate}
      defaultEndDate={uiEndDate}
      filter={filter}
    />
  );
}

export default DOutstandingRevenue;
